import Glide, { Controls, Keyboard, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import refs from '../helpers/refs'
import cart from '../helpers/cart-helper'
import datalayer from '../helpers/datalayer'
import ButtonHelper from '../helpers/button-helper'

class CCartReccos {
  constructor (el) {
    this.$root = el
    this.$refs = refs(el)

    this.init()

    setTimeout(() => {
      this.initSlider()
      this.bindEvents()
      this.clonesAriaHidden()
    }, 100)
  }

  init () {
    // Add to cart button won't exist if out of stock
    if (this.$refs.reccoAddToCartLink) {
      const links = this.$refs.reccoAddToCartLink

      links.forEach((link) => {
        const innerElem = link.children[0]
        const buttonHelper = new ButtonHelper(link, innerElem)

        link.addEventListener('click', (e) => {
          // Handle iOS Safari's buggy click event behavior
          e.preventDefault()
          e.stopPropagation()

          // Set text to loading
          buttonHelper.setPendingState()

          const linkUrl = e.currentTarget.href

          if (!linkUrl) {
            console.error('Unable to add recco product to cart. No link found.')
            return
          }

          const variantID = linkUrl.split('id=')[1].split('&')[0]
          cart.addProductsToCart([
            {
              id: variantID,
              quantity: 1
            }
          ], false, true)
            .then(() => {
              // Done adding to cart state
              buttonHelper.setDoneState()

              // Reset to initial state
              buttonHelper.resetStateOnDelay()
            })
        })
      })
    }

    // links around images and titles need to trigger productClick for GTM
    if (this.$refs.productLink) {
      this.$refs.productLink.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          e.stopPropagation()

          let linkNode
          // target may be an image, h4 or an anchor depending on the exact spot clicked
          // find the nearest anchor element grab the href
          if (e.target instanceof HTMLAnchorElement) {
            linkNode = e.target
          } else {
            linkNode = e.target.closest('a')
          }

          const targetUrl = linkNode.href

          if (linkNode.dataset.productHandle) {
            return new Promise((resolve, reject) => {
              datalayer.getProductByHandle(linkNode.dataset.productHandle)
                .then((response) => {
                  // console.log('Product click data response:', response)
                  return response
                })
                .then((data) => {
                  // console.log('Product click data resolve:', data)
                  datalayer.pushProductClickEvent(data, linkNode.dataset.productList, linkNode.dataset.productPosition, targetUrl)

                  resolve()
                })
                .catch((err) => {
                  console.error('Product click error:', err)

                  reject(err)
                })
            })
          }
        })
      })
    }
  }

  initSlider () {
    this.glide = new Glide(this.$refs.slider, {
      type: 'slider',
      autoheight: true,
      gap: 24,
      perView: 3,
      bound: true,
      breakpoints: {
        768: {
          perView: 1.3,
          gap: 16
        },
        1024: {
          perView: 2.3,
          gap: 16
        }
      }
    }).mount({ Controls, Keyboard, Breakpoints, Swipe })
  }

  bindEvents () {
    this.$refs.controls.forEach((control, i) => {
      control.addEventListener('click', (e) => {
        this.glide.go(`=${i}`)
        this.setControls(i)
      })
    })

    this.glide.on('run', () => {
      this.setControls(this.glide.index)
    })
  }

  setControls (index) {
    this.$refs.controls.forEach((control, i) => {
      control.classList.toggle('--active', i === index)
    })
  }

  clonesAriaHidden () {
    const cloneSelector = `.${this.glide.settings.classes.cloneSlide}`
    document
      .querySelectorAll(cloneSelector)
      .forEach(el => el.setAttribute('aria-hidden', 'true'))
  }
}

// Wait for images to load in
window.addEventListener('load', () => {
  document
    .querySelectorAll('.c-cart-reccos')
    .forEach(el => new CCartReccos(el))
})
